import { render, staticRenderFns } from "./SelectDoctorPage.vue?vue&type=template&id=6c772997&scoped=true"
import script from "./SelectDoctorPage.vue?vue&type=script&lang=js"
export * from "./SelectDoctorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c772997",
  null
  
)

export default component.exports